import { create } from "zustand";
import { devtools } from "zustand/middleware";
import { IndexedDBService } from "../../services/indexedDbService";

const DB_KEY = "stepsCredit";
const db = new IndexedDBService();

export const stepsCreditStore = create(
  devtools((set, get) => ({
    stepCredit: null,
    loading: false,

    loadSteps: async () => {
      const existing = await db.getItemByKey(DB_KEY);
      if (existing?.value) {
        existing.value.loading = true;
        set({ stepCredit: existing.value });
      }
    },

    saveSteps: async (partialOrFullDraft) => {
      const current = get().stepCredit || {};
      const updated = {
        ...current,
        ...partialOrFullDraft,
        updatedAt: new Date().toISOString(),
      };
      set({ stepCredit: updated });
      try {
        await db.setItemByKey(DB_KEY, updated); // persiste
      } catch (err) {
        console.error("Error guardando stepCredit en IDB:", err);
      }
    },

    // 🔹 Limpiar stepCredit
    clearSteps: async () => {
      await db.deleteItem(DB_KEY);
      set({ stepCredit: null });
    },
  }))
);
